import React, { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import './WorkspaceModal.scss';

export function workspaceUserInitials(name) {
  const parts = String(name || 'U').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  return (parts[0]?.[0] || 'U').toUpperCase();
}

/**
 * Workspace-styled modal (light header, Dhruv tokens). Use instead of raw Bootstrap Modal in platform shell.
 */
const WorkspaceModal = ({
  show,
  onHide,
  title,
  description,
  size = 'lg',
  children,
  footer,
  userProfile,
  className = '',
  onTestFill,
  enableTestFillHotkey = true
}) => {
  const sizeClass = size === 'lg' || size === 'xl' ? 'workspace-modal--lg' : '';
  const fillRef = useRef(onTestFill);
  fillRef.current = onTestFill;

  useEffect(() => {
    if (!show || !enableTestFillHotkey || typeof onTestFill !== 'function') return undefined;
    const handler = (e) => {
      if (!e.altKey) return;
      if (e.key !== 'F1' && e.code !== 'F1' && e.keyCode !== 112) return;
      e.preventDefault();
      fillRef.current?.();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [show, enableTestFillHotkey, onTestFill]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered
      className={`workspace-modal ${sizeClass} ${className}`.trim()}
      contentClassName="workspace-modal__content"
    >
      <Modal.Header closeButton className="workspace-modal__header">
        <div>
          <Modal.Title className="workspace-modal__title">{title}</Modal.Title>
          {description ? <p className="workspace-modal__description">{description}</p> : null}
        </div>
      </Modal.Header>
      <Modal.Body className="workspace-modal__body">
        {userProfile ? (
          <div className="workspace-modal__profile">
            <div className="workspace-modal__avatar" aria-hidden>
              {workspaceUserInitials(userProfile.name)}
            </div>
            <div>
              <div className="workspace-modal__profile-name">{userProfile.name}</div>
              <div className="workspace-modal__profile-email">{userProfile.email}</div>
            </div>
          </div>
        ) : null}
        {children}
      </Modal.Body>
      {footer ? <Modal.Footer className="workspace-modal__footer">{footer}</Modal.Footer> : null}
    </Modal>
  );
};

export default WorkspaceModal;
